import { render, staticRenderFns } from "./banner6.vue?vue&type=template&id=af77a94a&"
import script from "./banner6.vue?vue&type=script&lang=js&"
export * from "./banner6.vue?vue&type=script&lang=js&"
import style0 from "./banner6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports